


















































































































import { defineComponent, ref, watch } from '@vue/composition-api'
import { useStore } from '@/store'
import VPuzzle from '@/components/VPuzzle.vue'

export default defineComponent({
  name: 'Droogdokkenpark',

  components: {
    VPuzzle
  },

  props: {
    next: String
  },

  setup() {
    const { state } = useStore()
    const step = ref(1)

    watch(step, () => {
      const content = document.querySelector('.c-popover--open')
      if (content) {
        content.scrollTop = 0
      }
    })

    const pieces = [
      require('../../public/images/puzzel1-1.png'),
      require('../../public/images/puzzel1-2.png'),
      require('../../public/images/puzzel1-3.png'),
      require('../../public/images/puzzel1-4.png'),
      require('../../public/images/puzzel1-5.png'),
      require('../../public/images/puzzel1-6.png')
    ]

    return {
      state,
      step,
      pieces
    }
  }
})
